import { DOMcreateElement } from '../typescript/TSXDomParse';
import { FooterColumnContents } from './FooterColumn';
export default function FooterColumnMobile(_a) {
    var data = _a.data;
    return (DOMcreateElement("div", { className: "link-block" }, data.map(function (subCol) {
        var _a;
        return (DOMcreateElement(FooterColumnContents, { links: (_a = subCol.fields) === null || _a === void 0 ? void 0 : _a.components }));
    })));
}
